import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/user-services/auth.service';

@Component({
  selector: 'app-signout-callback',
  template: `<div></div>`
})
export class SignoutCallbackComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.completeLogout().then(() => {
      const targetRoute: string = window.localStorage.getItem('revoked') ? '/revoked-session' : '/';
      this.router.navigate([targetRoute], { replaceUrl: true });
    });
  }
}
